import React from "react";
import { makeStyles, Typography, Button } from "@material-ui/core";
import DictionaryEntry from "./DictionaryEntry";
import SecondaryPageTitle from "./SecondaryPageTitle";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "3rem",
    color: theme.palette.text.secondary,
    textAlign: "center",
    marginBottom: theme.spacing(2.5),
  },
  body: {
    fontSize: "1.25rem",
    color: theme.palette.text.primary,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function Mission() {
  const classes = useStyles()
  return (
    <div>
      <SecondaryPageTitle 
        title="Our Mission"
      />
      <DictionaryEntry />
    </div>
  );
}

export default Mission;
